import { render } from "./ModuleResultActions.vue?vue&type=template&id=4a178734&scoped=true"
import script from "./ModuleResultActions.vue?vue&type=script&lang=js"
export * from "./ModuleResultActions.vue?vue&type=script&lang=js"

import "./ModuleResultActions.vue?vue&type=style&index=0&id=4a178734&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a178734"]])

export default __exports__